import { makeStyles } from 'tss-react/mui';

export const useStyles = makeStyles()(() => ({
  p: {
    marginTop: 0,
    '&::first-letter': {
      textTransform: 'uppercase',
    },
    '&:not(:last-child)': {
      marginBottom: 0,
    },
  },
}));
